import {createFeatureSelector, createSelector} from '@ngrx/store';
import {GroupDashboardState} from './group-dashboard.reducer';

// Selector functions
const groupDashboardData = createFeatureSelector<GroupDashboardState>('ss-cord.group-dashboard');

export const groupDashboardParticipantInformation = createSelector(
  groupDashboardData,
  (state) => state.groupDashboardParticipantInformation.participantInformation
);

export const groupDashboardParticipantWeight = createSelector(
  groupDashboardData,
  (state) => state.groupDashboardParticipantWeight.participantWeight
);

export const groupDashboardParticipantWeightMean = createSelector(groupDashboardData, (state) => state.groupDashboardParticipantWeight.average)
export const groupDashboardParticipantBehaviorRedLights = createSelector(groupDashboardData, (state) => state.groupDashboardParticipantBehaviorRedLights.participantBehaviorRedLights)
export const groupDashboardParticipantBehaviorRedLightsAverage = createSelector(groupDashboardData, (state) => state.groupDashboardParticipantBehaviorRedLights.average)

export const groupDashboardParticipantBehaviorPhysicalActivity = createSelector(groupDashboardData, (state) => state.groupDashboardParticipantBehaviorPhysicalActivity.participantBehaviorPhysicalActivity)
export const groupDashboardParticipantBehaviorPhysicalActivityDataAverage = createSelector(groupDashboardData, (state) => state.groupDashboardParticipantBehaviorPhysicalActivity.average)

export const groupDashboardParticipantBehaviorScreenTime = createSelector(groupDashboardData, (state) => state.groupDashboardParticipantBehaviorScreenTime.participantBehaviorScreenTime)
export const groupDashboardParticipantBehaviorScreenTimeDataAverage = createSelector(groupDashboardData, (state) => state.groupDashboardParticipantBehaviorScreenTime.average)

export const dashboardFilter = createSelector(
  groupDashboardData,
  (state: GroupDashboardState) => state.dashboardFilter
);

export const participantsAndCaregiversList = createSelector(
  groupDashboardData,
  (state: GroupDashboardState) => state.participantsAndCaregiversList
);

export const groupsTypeFilter = createSelector(
  groupDashboardData,
  (state: GroupDashboardState) => state.groupsTypeFilter
);

export const userStatusListFilter = createSelector(
  groupDashboardData,
  (state: GroupDashboardState) => state.userStatusListFilter
);

export const participantsWeightList = createSelector(
  groupDashboardData,
  (state: GroupDashboardState) => state.participantsWeightList
);

export const configId = createSelector(
  groupDashboardData,
  (state: GroupDashboardState) => state.configId
);

export const participantsBehaviourList = createSelector(
  groupDashboardData,
  (state: GroupDashboardState) => state.participantsBehaviourList
);
